import { useFormikContext } from 'formik';
import { type ReactElement, useContext } from 'react';

import { SlabContext } from '@core/context/SlabContext';
import type { ProjectFormikType } from '@core/formik/project';
import Enums from '@core/types/api/Enums';
import { AddressMapField } from '@web/components/Address/AddressMapField';

export const ProjectAddressSection = (): ReactElement => {
  const ctx = useContext(SlabContext);
  const formikBag = useFormikContext<ProjectFormikType>();

  const isCityRequired = ctx.userInfo.hasFlags([
    Enums.FeatureFlagName.FeatureFlagRequiresProjectAddressCity,
  ]);

  const isFullyRequired = ctx.userInfo.hasFlags([
    Enums.FeatureFlagName.FeatureFlagRequiresProjectAddress,
  ]);

  return (
    <AddressMapField
      onAddressChange={(address) => {
        formikBag.setFieldValue('address', address);
      }}
      name='address'
      isCityRequired={isCityRequired}
      isRequired={isFullyRequired}
      pinTypes={['competitor-plant', 'plant']}
    />
  );
};
